import React, { useState, useEffect } from "react";
import { useQuery, useQueryClient } from 'react-query'
import { getResultRSC_H2H } from "data/Querys"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ScoreHorizontal, { ScorePeriodBox } from 'components/common/ScoreHorizontal'
import Loader from 'components/general/Loader'
import { findArray, filterArray } from 'helpers/utils'
import { getSportCodeEntityObjects } from 'components/common/SportCode'
import Label from "components/general/Label";
import NotAvailable from 'components/common/NotAvailable'
import {
  RESULT_STATUS,
  getResultStatusAsInteger,
  isStartListStatus
} from "helpers/status";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import PageHeader from "components/common/PageHeader";
import Competitor from "components/presentation/Competitor";
import { Collapse } from "react-bootstrap"
import ActionLine from "components/common/ActionLine";
import { useViewport } from 'components/general/useViewPort';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import SportCode from "components/common/SportCode";

//Start List
import Ru7StartList from 'components/sports/ru7/views/Ru7StartList'
//Play by play
import Ru7Pbp from 'components/sports/ru7/views/Ru7Pbp'
//Team Statistics
import Ru7TeamStats from 'components/sports/ru7/views/Ru7TeamStats'
//Players Statistics
import Ru7PlayerStats from 'components/sports/ru7/views/Ru7PlayerStats'

const Ru7Context = () => {
  const { mirs_discipline, mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
  const queryClient = useQueryClient();
  const [periodsOrder, setPeriodsOrder] = useState()
  useEffect(() => {
    const dataSportCodes = queryClient.getQueryData(["SportCodes", mirs_competition, mirs_language])?.sportCodes;
    const periodsCodes = getSportCodeEntityObjects(dataSportCodes, mirs_discipline, '@Period');
    const periodsOrder_ = periodsCodes ? periodsCodes?.map(p => ({ period: p.sportCode, order: parseInt(p.order) }))?.sort((a, b) => a.order - b.order) : [];
    setPeriodsOrder(periodsOrder_)
  }, [])

  const { breakPoint } = useViewport()

  //datos para el marcador y estadisticas
  const { data, isError, isLoading } = useQuery(
    {
      queryKey: ['resultsDataH2H', mirs_competition, mirs_rsc, mirs_language],
      queryFn: getResultRSC_H2H,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
      //enabled: !!confCategory
      onError: (error) =>
        console.error(`Something went wrong: ${error.message}`),
    });

  if (isError) { return <NotAvailable /> }
  if (isLoading || !periodsOrder) { return <Loader /> }
  if (!data?.results) { return <NotAvailable /> }

  let tabStartList = false;
  let tabDisabled = false;
  const resultStatus = data?.results?.status?.code;

  if (getResultStatusAsInteger(resultStatus) < RESULT_STATUS.START_LIST) {
    tabStartList = true;
  }
  if (getResultStatusAsInteger(resultStatus) < RESULT_STATUS.LIVE) {
    tabDisabled = true;
  }


  if (!data?.results) { return <NotAvailable /> }
  let homeFaults = findArray(findArray(data?.results?.items, { startSortOrder: [1] }).statsItems, { code: ['PF_TEAM'] }).value;
  let awayFaults = findArray(findArray(data?.results?.items, { startSortOrder: [2] }).statsItems, { code: ['PF_TEAM'] }).value;
  let statusMatch = data?.results?.status.code
  let showFaultsInLive;
  let matchAttendance = findArray(data?.results?.extendedInfos, { ei_code: ['ATTENDANCE'] })?.ei_value;
  if (matchAttendance) {
    matchAttendance = <><Label data='HeaderAttendance' />: {matchAttendance}</>
  }

  if (getResultStatusAsInteger(statusMatch) === RESULT_STATUS.LIVE) {
    showFaultsInLive = <>
      <div className='score-horizontal-extra-information-box'>
        {homeFaults}
      </div>
      <div className='score-horizontal-extra-information-box'>
        Faults
      </div>
      <div className='score-horizontal-extra-information-box'>
        {awayFaults}
      </div>
    </>
  }


  let score = <ScoreHorizontal
    data={data}
    scoreBody={{
      bottom: breakPoint === "sm" || breakPoint === "xs" ? '' : <GetScorers results={data?.results} />
    }}
    scoreFooter={{
      top: <Periods data={data?.results?.periods} />,
    }
    }
  />


  return (
    <>
      <PageHeader data={data} />
      <div className='mirs-page-container'>
      <div className='my-5'>
        {score}
      </div>
      <Tabs id="mirs-navsport" defaultActiveKey={isStartListStatus(resultStatus) ? `1-${mirs_rsc}` : `2-${mirs_rsc}`} className="mb-3 mirs-tab-result">
        <Tab eventKey={`1-${mirs_rsc}`} title={(<Label data='HeaderStartList' />)} disabled={tabStartList} >
          <Ru7StartList data={data} />
        </Tab>
        <Tab eventKey={`2-${mirs_rsc}`} title={(<Label data='HeaderPlayByPlay' />)} disabled={tabDisabled} >
          <ActionLine />
          <Ru7Pbp data={data} periodsOrder={periodsOrder} />
        </Tab>
        <Tab eventKey={`3-${mirs_rsc}`} title={(<Label data='HeaderTeamStatistics' />)} disabled={tabDisabled}>
          <Ru7TeamStats data={data} />
        </Tab>
        <Tab eventKey={`4-${mirs_rsc}`} title={(<Label data='HeaderPlayerStats' />)} disabled={tabDisabled}>
          <Ru7PlayerStats data={data} team={1} />
          <Ru7PlayerStats data={data} team={2} />
        </Tab>
      </Tabs>
      </div>
    </>
  );
};

export default Ru7Context;


function Periods({ data }) {
  if (data) {
    //console.log(data)
    return (
      <>
        {filterArray(data, { p_code: ['H1', 'H2', 'OT'] }).map((item, index) => (
          <ScorePeriodBox
            key={'scorePeriodBlock' + index}
            //periodTop={item.p_code}
            periodTop={<SportCode code={item.p_code} discipline="RU7" entity="@Period" />}
            periodBottom={item.home.score + ' - ' + item.away.score} />
        ))}
      </>
    )
  }
}


const GetScorers = ({ results }) => {

  const resultStatus = results?.status?.code;
  let showScoretag = true
  let showCurrent = false
  if (getResultStatusAsInteger(resultStatus) < RESULT_STATUS.LIVE) {
    showScoretag = false;
  }
  if (getResultStatusAsInteger(resultStatus) === RESULT_STATUS.LIVE) {
    showCurrent = true && results?.periods?.find(p => p.p_code === 'PSO');
  }
  const scorers = getScorersData(results)
  let playerForTeam = ''
  const [isNavCollapsed, setIsNavCollapsed] = useState(false);
  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  const [isNavCollapsed2, setIsNavCollapsed2] = useState(false);
  const handleNavCollapse2 = () => setIsNavCollapsed2(!isNavCollapsed2);
  let scorersArray_H = scorers && scorers.filter(s => s.side === 'H')?.sort((a, b) => b.order - a.order)
  let scorersArray_A = scorers && scorers.filter(s => s.side === 'A')?.sort((a, b) => b.order - a.order)
  if (scorers) {
    playerForTeam = (
      <>
        <div className="flex-row w-100">
          <div className="text-center score-horizontal-extra-information-box">{showScoretag && <Label data='LabelScorers' />}</div>
          <div className="flex-column d-flex w-100" >
            <div className="d-flex justify-content-center">

              <div key='ScoreHome' className='d-flex  justify-content-end navbar-light  score-horizontal-extra-information-box-normal text-end w-40'>
                <div className="me-1">
                  <div>
                    {scorersArray_H?.map((item, index) => {
                      if (index === 0) {
                        return (
                          <span key={'OlympicRoundHome-' + item?.order} className="d-flex justify-content-end">
                            <Competitor hidePicture={true} hideNoc={true} {...item?.ath} />&nbsp;<span className="ps-1">{item?.pts}</span>&nbsp;<span className="ps-1">{item?.when}</span>
                          </span>
                        )
                      }
                    }
                    )}
                  </div>
                  <Collapse in={isNavCollapsed2}>
                    <div id="navbarsHome">
                      {scorersArray_H?.map((item, index) => {
                        if (index > 0) {
                          return (
                            <span key={'OlympicRoundHome-' + item?.order} className="d-flex justify-content-end">
                              <Competitor hidePicture={true} hideNoc={true} {...item?.ath} />&nbsp;<span className="ps-1">{item?.pts}</span>&nbsp;<span className="ps-1">{item?.when}</span>
                            </span>
                          )
                        }
                      }
                      )}
                    </div>
                  </Collapse>
                </div>
                <div  >
                  {scorersArray_H.length > 1 &&
                    <button
                      className="custom-toggler"
                      type="button"
                      style={{ border: "unset", backgroundColor: "transparent" }}
                      aria-controls="navbarsHome" aria-expanded={isNavCollapsed2}
                      onClick={handleNavCollapse2}>
                      <FontAwesomeIcon className=" font-icon fa-xs" icon={isNavCollapsed2 ? faCaretUp : faCaretDown} />
                    </button>
                  }
                </div>
              </div>

              <div key='ScoreCenter' className='score-horizontal-extra-information-box w-20 text-center'></div>

              <div key='ScoreAway' className='d-flex  justify-content-start navbar-light  score-horizontal-extra-information-box-normal text-start w-40'>
                <div  >
                  {scorersArray_A.length > 1 &&
                    <button
                      className="custom-toggler  "
                      type="button"
                      style={{ border: "unset", backgroundColor: "transparent" }}
                      aria-controls="navbarsAway" aria-expanded={isNavCollapsed}
                      onClick={handleNavCollapse}>
                      <FontAwesomeIcon className=" font-icon fa-xs" icon={isNavCollapsed ? faCaretUp : faCaretDown} />
                    </button>
                  }
                </div>
                <div className="ms-1">
                  <div>
                    {scorersArray_A?.map((item, index) => {
                      if (index === 0) {
                        return (
                          <span key={'OlympicRoundAway-' + item?.order} className="d-flex justify-content-start">
                            <span className="ps-1">{item?.when}</span>&nbsp;<span className="ps-1">{item?.pts}</span>&nbsp;<Competitor hidePicture={true} hideNoc={true} {...item?.ath} />
                          </span>
                        )
                      }
                    }
                    )}
                  </div>
                  <Collapse in={isNavCollapsed}>
                    <div id="navbarsAway">
                      {scorersArray_A?.map((item, index) => {
                        if (index > 0) {
                          return (
                            <span key={'OlympicRoundAway-' + item?.order} className="d-flex justify-content-start">
                              <span className="ps-1">{item?.when}</span>&nbsp;<span className="ps-1">{item?.pts}</span>&nbsp;<Competitor hidePicture={true} hideNoc={true} {...item?.ath} />
                            </span>
                          )
                        }
                      }
                      )}
                    </div>
                  </Collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
  return playerForTeam;
}


const getScorersData = (results) => {
  let scorers = []
  results?.playByPlay?.forEach(p => {
    p?.actions.forEach(a => {
      if (a.pbpa_Result === 'GOAL' && a.competitors && a.competitors[0].athletes && a.competitors[0]?.athletes[0]?.pbpat_code) {

        let scorer = {
          when: a?.pbpa_When ? a?.pbpa_When : '',
          period: p?.subcode,
          order: a?.pbpa_order,
        }
        const athHome = results?.home?.teamAthletes?.find(item => item?.athlete?.code === a.competitors[0]?.athletes[0]?.pbpat_code);
        const athAway = results?.away?.teamAthletes?.find(item => item?.athlete?.code === a.competitors[0]?.athletes[0]?.pbpat_code);
        if (athHome) {
          scorer.ath = athHome?.athlete
          scorer.side = 'H'
          scorer.pts = findArray(athHome?.statsItems, { code: ['PTS'] }).value
        } else {
          scorer.ath = athAway?.athlete
          scorer.side = 'A'
          scorer.pts = findArray(athAway?.statsItems, { code: ['PTS'] }).value
        }
        scorers.push(scorer)
      }
    })
  })

  const scorersReduced = [];
  scorers?.forEach(s => {
    let multipleScorer = scorersReduced?.find(sr => sr.ath === s.ath);
    if (multipleScorer) {
      multipleScorer.period = multipleScorer?.period === 'PSO' ? s?.peridod : multipleScorer?.period
      multipleScorer.when = multipleScorer?.when && s.when ? multipleScorer.when + ", " + s.when : multipleScorer?.when ? multipleScorer?.when : s.when ? s.when : '';
    } else {
      scorersReduced.push(s)
    }
  })

  return scorersReduced
}
